module.exports = __webpack_public_path__ + "static/media/meat1.abf82cf6.jpg";